module.exports = __webpack_public_path__ + "img/043-file-video.d56b56e8.svg";